import { render, staticRenderFns } from "./NoAccess.vue?vue&type=template&id=ad550536&"
import script from "./NoAccess.vue?vue&type=script&lang=js&"
export * from "./NoAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NoAccess.vue"
export default component.exports